import {
  ListItemIcon,
  ListItemText,
  MenuItem as MuiMenuItem,
  Typography,
} from "@mui/material";
import { observer } from "mobx-react";
import * as React from "react";
import { useCallback, useMemo } from "react";
import { ActionMenuItem } from "src/pi/application/Menu";
import app from "../../../../application/App";
import DynamicIcon from "../../DynamicIcon";

interface IProps {
  item: ActionMenuItem;
  showIcon?: boolean;
}

const ActionMenuItemComponent: React.FC<IProps> = observer((props) => {
  const { item, showIcon } = props;

  const appStore = useMemo(() => app(), []);

  const onExecute = useCallback(() => {
    if (!item.action) return;
    appStore.executeAsync(item.action);
  }, [appStore, item]);

  return (
    <MuiMenuItem key={item.name} onClick={onExecute} disabled={!item.isEnabled}>
      {showIcon && (
        <ListItemIcon>
          <DynamicIcon icon={item.data.icon} color="inherit" />
        </ListItemIcon>
      )}
      <ListItemText primary={item.label} />
    </MuiMenuItem>
  );
});

export default ActionMenuItemComponent;
